//@ts-nocheck

import pageTransition from './components/pageTransition'
import contentSliders from './components/contentSliders'
import header from './components/header'
import intersection from './components/intersection'
import loadWorks from './components/loadWorks'
import postCategoryFilter from './components/postCategoryFilter'
import textSliders from './components/textSliders'
import loadingText from './components/loadingText'
import relatedSlider from './components/relatedSlider'
import profileCards from './components/profileCards'
import faqAccordion from './components/accordion'

const init = () => {
  header()
  intersection()
  contentSliders()
  loadWorks()
  postCategoryFilter()
  textSliders()
  loadingText()
  relatedSlider()
  profileCards()
  faqAccordion()
  // pageTransition();
}

init()
